$(function(){
   $.fn.myUpDown=function(options,timeHandlerObj){
        if(typeof options=="undefined"){
            options={};
        }
        var settings = $.extend( {
            pos:[null,null,null,null],
            rotation:90,//90,180,270,0
            range:15,//px -/+ max
            speed:2,//px on step
            position:"absolute",
        }, options);
        
        var pos_keys={"top":0,"right":1,bottom:2,"left":3},
        rotation2direction={"0":"top","90":"right","180":"bottom","270":"left"};
        var val,key,was_set=0;
        for(key in pos_keys){
            val=pos_keys[key];
            if(typeof options[key]!="undefined"){
                settings.pos[intval(val)]=options[key];
                was_set++;
            }
        }
        if(was_set>1){
            options.pos=copyArray(settings.pos);
        }
        if(typeof timeHandlerObj=="undefined"){
            timeHandlerObj=_moduleTimeHandler;
        }
        var th=$(this);
        var set;
        var objectData=th.data("myUpDown");
        if(objectData && typeof objectData!="undefined"){
            set=$.extend( objectData, options);
        }
        else{
            set=copyObj(settings);
        }
        
        var htmlData=th.data(),i,bum,key,setCss={"position":set.position};
        if(typeof htmlData=="undefined"){
            htmlData={};
        }
        else{
            set= $.extend( set, htmlData);
        }
        for(key in pos_keys){
            i=pos_keys[key];
            if(typeof htmlData[key]!="undefined"){
                set.pos[i]=htmlData[key];

            }
            if(set.pos[i]!==null){
                 setCss[key]=set.pos[i]+"px";
            }
        }
        setCss[rotation2direction[set.rotation]]="auto";
        th.css(setCss).attr("data-rotation",set.rotation);//clearRotation
        if(typeof set.timeHandlerIndex!="undefined"){
            timeHandlerObj.clear(set.timeHandlerIndex);
        }
        else{
            set.timeHandlerIndex=timeHandlerObj.getNewIndex();
        }

        th.data("myUpDown",set);
        var step=0,dir=set.speed,step_max=set.range;
        timeHandlerObj.set(set.timeHandlerIndex,function(){

            step+=dir;
            if(dir>0 && step>= step_max){
                step=step_max;
                dir=-set.speed;
            }
            if(dir<0 && step<=-step_max){
                dir=set.speed;
                step=-step_max;
            }
            var direction=rotation2direction[set.rotation],
            direction_op=rotation2direction[(set.rotation+180)%360],
            direction_cur;
            if(set.pos[pos_keys[direction_op]]!==null){
                direction_cur=direction_op;
            }
            else{
                direction_cur=direction;
            }

            th.css(direction_cur,(step+set.pos[pos_keys[direction_cur]])+"px");
        },40);
        return this;
   }; 
});